import { Theme } from "@mui/material";

export const getCardStyles = (theme: Theme, isPopular: boolean) => ({
  position: "relative",
  overflow: "visible",
  padding: { xs: 3, md: 2 },
  border: `${isPopular
    ? `1px solid ${theme.palette.primary.main}`
    : `1px solid transparent`
    }`,
  backgroundColor: `${isPopular ? "#FFF8F3" : "transparent"}`,
  borderRadius: "12px",
  marginBottom: { xs: 3, md: 0 },
  marginTop: { xs: 2, md: 3 },
});
